import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Svojina } from './svojina';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-svojina',
  templateUrl: './svojina.component.html'
})
export class SvojinaComponent extends BaseModalContainer<Svojina> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Svojina>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
